/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { ChevronLeft } from '@mui/icons-material';
import { Box } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { type ReactNode } from 'react';

type ToggleDrawerButtonProps = {
	isSidebarOpen: boolean;
	onToggleSidebar: () => void;
};

export function ToggleDrawerButton( { isSidebarOpen, onToggleSidebar }: ToggleDrawerButtonProps ): ReactNode {
	return (
		<div style={ { justifyContent: 'flex-end', display: 'flex' } }>
			<Box
				sx={ {
					backgroundColor: 'common.white',
					position: 'absolute',
					right: isSidebarOpen ? 'var(--sidebar-padding-x)' : '7px',
					top: 'var(--sidebar-padding-y)'
				} }
			>
				<IconButton
					onClick={ onToggleSidebar }
					sx={ {
						padding: '10px',
						width: '28px',
						height: '28px',
						borderRadius: '2px',
						border: '1px solid rgba(0, 0, 0, 0.12)'
					} }
					data-testid={ 'sidebar-close-button' }
				>
					<ChevronLeft sx={ { transform: isSidebarOpen ? 'none' : 'rotate(180deg)' } }/>
				</IconButton>
			</Box>
		</div>
	)
	;
}
